<template>
  <el-dialog
    v-model="visibleDialog"
    title="型号注册"
    width="1500px"
    :z-index="2000"
    @closed="hide">
    <el-form
      class="RegisterForm"
      :model="registerForm"
      label-position="top"
      size="mini">
      <div class="d-flex justify-content-between">
        <el-form-item label="model">
          <el-input
            v-model="registerForm.model"
            placeholder="model"
          ></el-input>
        </el-form-item>
        <el-form-item label="type" style="width: 165px">
          <el-select v-model="registerForm.type" placeholder="type">
            <el-option label="Android" value="0"></el-option>
            <el-option label="iOS" value="1"></el-option>
            <el-option label="PC" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="rank">
          <el-input
            v-model="registerForm.rank"
            placeholder="rank"
          ></el-input>
        </el-form-item>
        <el-form-item label="score">
          <el-input
            v-model="registerForm.score"
            placeholder="score"
          ></el-input>
        </el-form-item>
        <el-form-item label="user_rank">
          <el-input
            v-model="registerForm.user_rank"
            placeholder="user_rank"
          ></el-input>
        </el-form-item>
        <el-form-item label="user_percentage">
          <el-input
            v-model="registerForm.user_percentage"
            placeholder="user_percentage"
          ></el-input>
        </el-form-item>
        <el-form-item label="name">
          <el-input
            v-model="registerForm.name"
            placeholder="name"
          ></el-input>
        </el-form-item>
      </div>
      <div class="d-flex justify-content-between mt-4">
        <el-form-item label="oem">
          <el-input
            v-model="registerForm.oem"
            placeholder="oem"
          ></el-input>
        </el-form-item>
        <el-form-item label="cpu_name">
          <el-input
            v-model="registerForm.cpu_name"
            placeholder="cpu_name"
          ></el-input>
        </el-form-item>
        <el-form-item label="cpu_model">
          <el-input
            v-model="registerForm.cpu_model"
            placeholder="cpu_model"
          ></el-input>
        </el-form-item>
        <el-form-item label="core_num">
          <el-input
            v-model="registerForm.core_num"
            placeholder="core_num"
          ></el-input>
        </el-form-item>
        <el-form-item label="ram">
          <el-input
            v-model="registerForm.ram"
            placeholder="ram"
          ></el-input>
        </el-form-item>
        <el-form-item label="gpu_name">
          <el-input
            v-model="registerForm.gpu_name"
            placeholder="gpu_name"
          ></el-input>
        </el-form-item>
        <el-form-item label="resolution">
          <el-input
            v-model="registerForm.resolution"
            placeholder="resolution"
          ></el-input>
        </el-form-item>
      </div>
    </el-form>
    
    <template #footer>
      <div class="dialog-footer text-center">
        <el-button size="mini" @click="hide">取消</el-button>
        <el-button type="primary" size="mini" @click="RegisterForm">
          注册
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { ElMessage } from "element-plus"
import axios from 'axios'
import {ref} from 'vue'
import {getLocalProject} from "@/utils"

export default {
  setup() {
    const visibleDialog = ref(false),
      registerForm = ref({
        model: "",
        type: "",
        rank: "",
        score: "",
        user_rank: "",
        user_percentage: "",
        name: "",
        oem: "",
        cpu_name: "",
        cpu_model: "",
        core_num: "",
        ram: "",
        gpu_name: "",
        resolution: "",
      }),
      project = getLocalProject()

    async function ResetBtn() {
      registerForm.value = {
        model: "",
        type: "",
        rank: "",
        score: "",
        user_rank: "",
        user_percentage: "",
        name: "",
        oem: "",
        cpu_name: "",
        cpu_model: "",
        core_num: "",
        ram: "",
        gpu_name: "",
        resolution: "",
      }
    }

    async function RegisterForm() {
      const form = registerForm.value
      let data = {
        model: form.model,
        type: Number(form.type),
        rank: Number(form.rank),
        score: Number(form.score),
        user_rank: Number(form.user_rank),
        user_percentage: form.user_percentage,
        name: form.name,
        oem: form.oem,
        cpu_name: form.cpu_name,
        cpu_model: form.cpu_model,
        core_num: Number(form.core_num),
        ram: Number(form.ram),
        gpu_name: form.gpu_name,
        resolution: form.resolution,
        project,
      };
      const {status} = await axios.post('device/device_specs_list/', data)

      if (status >= 200 && status < 300) {
        ElMessage({
          message: "型号注册成功",
          type: "success",
        })
        hide()
      }
    }

    function hide() {
      visibleDialog.value = false
      ResetBtn()
    }

    function show() {
      visibleDialog.value = true
    }

    return {visibleDialog, registerForm, show, hide, RegisterForm}
  }
}
</script>